import { Col, Row, Typography } from 'antd';
import React from 'react';

import { SharedCard } from '@components';
import { L } from '@lib';
import { GetUserOutput } from '@services';

const { Text } = Typography;

interface IProps {
  user: GetUserOutput;
}

export const UserDetailsCard: React.FC<IProps> = ({ user }) => {
  return (
    <>
      <Row style={{ marginTop: '20px' }}>
        <Col span={24}>
          <SharedCard title={`${user.name} ${user.surname}`}>
            <Row>
              <Col span={6}>
                <Text className="label--small nowrap">{L('PHONE')}</Text>
              </Col>
              <Col offset={1} span={12}>
                <Text className="label--small nowrap">{L('EMAIL')}</Text>
              </Col>
            </Row>
            <Row>
              <Col span={6}>
                <Text style={{ color: 'black' }} strong>
                  {user.phoneNumber}
                </Text>
              </Col>
              <Col offset={1} span={12}>
                <Text style={{ color: 'black' }} strong>
                  {user.emailAddress}
                </Text>
              </Col>
            </Row>
          </SharedCard>
        </Col>
      </Row>
    </>
  );
};
